import { render, staticRenderFns } from "./ownerDetailAccount.vue?vue&type=template&id=b60eb7da&scoped=true"
import script from "./ownerDetailAccount.vue?vue&type=script&lang=js"
export * from "./ownerDetailAccount.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailAccount.vue?vue&type=style&index=0&id=b60eb7da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60eb7da",
  null
  
)

export default component.exports